export const RouteEnum = {
	LOGIN: '/login',
	REGISTER: '/register',
	PRELOADER: '/preloader',
	HOME: '/',
	PRODUCTS: '/',
	PRODUCTS_DETAIL: '/products/:id',
	ABOUT: '/about',
	CONTACT_US: '/contact-us',
	BLOG: '/blog',
	BLOG_DETAIL: '/blog/:slug',
	BLOG_POSTS: 'blog/posts',
	CART: '/cart',
	CAREERS: '/careers',
	CHECKOUT: '/checkout',
	ACCOUNT: '/account',
	ADMIN_DASHBOARD: '/admin',
	ADMIN_PRODUCTS: '/admin/products',
	ADMIN_PRODUCTS_ADD: '/admin/products/add',
	ADMIN_ORDERS: '/admin/orders',
	ADMIN_DISTRIBUTORS: '/admin/distributors',
};

export const StoreQueryTagEnum = [];

export const languageFAQContentEnum = {
	en: 1,
	jp: 2,
};
